<div class="order-confirmation-hero-header" *ngIf="(orderId$ | async) && (locationNo$ | async)">
    <shared-order-info [orderId]="(orderId$ | async)" [locationNo]="(locationNo$ | async)"></shared-order-info>
    <shared-order-confirmation-mark class="order-confirmation-hero-header__mark"></shared-order-confirmation-mark>
</div>
